module.exports = __webpack_public_path__ + "static/media/ourstories-screen_yoga-pose-in-chair.661b8ffd.png";